export const thai = {
  // Language selection
  language: "ภาษา",
  thai: "ไทย",
  english: "อังกฤษ",
  chinese: "จีน",
  
  // Button labels
  save: "บันทึก",
  saveColumns: "บันทึกคอลัมน์",
  search: "ค้นหา",
  clear: "ล้าง",
  add: "เพิ่ม",
  edit: "แก้ไข",
  delete: "ลบ",
  cancel: "ยกเลิก",
  ok: "ตกลง",
  close: "ปิด",
  
  // Column headers and labels commonly used in shipping
  customer: "ลูกค้า",
  jobNo: "Job No.",
  containerNo: "เลขตู้",
  booking: "Booking/BL No.",
  etd: "ETD",
  eta: "ETA",
  status: "สถานะ",
  invoice: "Invoice",
  shippingProcess: "กระบวนการขนส่ง",
  import: "นำเข้า",
  export: "ส่งออก",
  
  // Filter labels
  filter: "กรอง",
  searchNumber: "ค้นหาหมายเลข",
  searchValue: "ค่าที่ค้นหา",
  noFilter: "ไม่ระบุ",
  notSpecified: "ไม่ระบุ",
  
  // Messages
  saveSuccess: "บันทึกคอลัมน์เรียบร้อยแล้ว",
  searchRequired: "กรุณาใส่เงื่อนไขการค้นหาอย่างน้อย 1 รายการ",
  
  // Shipping specific terms
  blReceived: "รับ B/L",
  enterMBL: "Enter MB/L",
  freightInvoice: "Inv สายเรือ",
  doReceived: "รับ DO",
  customsForm: "Draft ใบขน",
  customsClear: "พร้อมตรวจปล่อย",
  
  // Navigation
  jumpToDO: ">>รับ DO>>",
  jumpToCustomsClear: ">>ตรวจปล่อย>>",
  jumpToIssue: ">>Issue>>",

  // Shipping column names
  Service: "Service",
  CusAbbr: "รหัสลูกค้า",
  IP_InvNo: "Invoice No.",
  IP_InvDte: "วันที่ Invoice",
  Bkg: "Booking",
  IP_Csgn: "Consignee",
  IP_ETD: "ETD",
  Note: "Note",
  IP_PO: "PO",
  IP_PoL: "Port of Loading",
  IP_PoD: "Port of Discharge",
  PLCreTm: "เวลารับ PL",
  OwnAccId: "ผู้ส่ง PL",
  OwnAccNm: "ผู้ส่ง PL",
  OwnAccEmail: "Email ผู้ส่ง PL",
  EDCreTm: "เวลาเพิ่ม Draf ใบขน",
  EDCreAccId: "ผู้สร้างใบขน",
  EDCreAccNNm: "ผู้สร้างใบขน",
  EDNo: "เลขที่ใบขน",
  EDAprvTm: "เวลาตรวจสอบใบขน",
  EDSndTm: "เวลาส่งใบขน",
  EDCfTm: "เวลายืนยันใบขน",
  ED0209CreTm: "เวลาสร้างใบขน",
  ED0209SndTm: "เวลาส่งสถานะ0209",
  ED0309CreTm: "เวลาเพิ่มสถานะ0309",
  ED0309SndTm: "เวลาส่งสถานะ0309",
  ED0409CreTm: "เวลาเพิ่มสถานะ0409",
  ED0409SndTm: "เวลาส่งสถานะ0409",
  CDCreTm: "เวลาสร้างใบกำกับตู้",
  CDCreAccId: "ผู้สร้างใบกำกับตู้",
  CDCreAccNNm: "ผู้สร้างใบกำกับตู้",
  CDAprvTm: "เวลาตรวจสอบใบกำกับตู้",
  CDSndTm: "เวลาส่งใบกำกับตู้",
  PayCstmTm: "เวลาจ่ายศุลกากร",
  Rmk: "หมายเหตุ",
  GrossWt: "G.W.",
  TotalGW: "Total G.W.",
  CT: "จำนวนหีบห่อ/หน่วย(CT)",
  KGM: "น้ำหนักรวมหีบห่อ/หน่วย(KGM)",
  M3: "ปริมาตร(M3)",
  Vol: "จำนวนตู้",
  TotalKGM: "VGM WEIGHT",
  ShpTypId: "ประเภทยานภาหนะ",
  Cnee: "Consignee",
  CneeNm: "Consignee",
  CneeSNm: "Consignee",
  BLRecvTm: "เวลา รับ B/L",
  InvPLTm: "เวลา รับ Inv/PL",
  BLCfTm: "เวลา Confirm HBL",
  BLSndTm: "เวลาส่ง HBL",
  ANRecvTm: "เวลารับ Notice",
  MBLRecvTm: "เวลารับ MBL",
  MBLEntrTm: "เวลา Enter MBL",
  FrtInvTm: "เวลา Inv สายเรือ",
  FrtInvPaidTm: "เวลาชำระเงินสายเรือ",
  DOMailTm: "เวลาส่งจ.ม.แลก D/O",
  DORecvTm: "เวลารับ D/O",
  CstmFormDfTm: "Draft ใบขน",
  CstmFormCfTm: "Confirm ใบขน",
  CstmClrTm: "วันที่ตรวจปล่อย",
  BLSts: "สถานะงาน",
  DemFreeTm: "Dem Free Time",
  DemStDte: "Dem Start Date",
  DetFreeTm: "Det Free Time",
  DetStDte: "Det Start Date",
  ContNos: "หมายเลขเลขตู้ใน B/L",
  ContNoStr: "หมายเลขเลขตู้ใน B/L",
  ManAccNNm: "Shp",
  ManAccNNmCS: "CS",
  ManAccNNmDoc: "Doc",
  ManAccNNmSugg: "ผู้แนะนำ",
  ManAccNNmSale: "Sale",
  ManAccId: "Shp",
  ManAccIdCS: "CS",
  ManAccIdDoc: "Doc",
  ManAccIdSugg: "ผู้แนะนำ",
  ManAccIdSale: "Sale",
  SealContTm: "วันปิดตู้",
  ScId: "จ้าง Shipping",
  FormTm: "เวลาฟอร์มต่างๆ",
  DocSndTm: "เวลาส่งเอกสารตัวจริง",
  Brnd: "ตราสินค้า",
  IssuId: "Issue",
  IssuNm: "Issue",
  ShpRunSt: "เวลาออกตรวจปล่อย",
  ShpRunEn: "เวลาได้การ์ด",
  ShpInvServNm: "Service",
  ShpContNos: "เลขตู้ใน B/L",

  // Issue columns
  Prty: "Priority",
  Clr: "สี Issue",
  IssuTm: "เวลา Issue",
  Dscp: "รายละเอียด Issue",
  IsFix: "แก้ไข",

  // Additional terms
  addInvoice: "เพิ่มใบแจ้งลาก",
  linkInvoice: "ผูกใบแจ้งลาก",
  issueTable: "ตาราง Issue",
  responsible: "ผู้รับผิดชอบงาน",
  hireShipping: "จ้าง Shipping",
  notHireShipping: "ไม่จ้าง Shipping",
  hireShippingStatus: "สถานะจ้าง",
  truckStatus: "สถานะแจ้งรถ",
  notNotifiedTruck: "ยังไม่แจ้งรถ",
  truckNotified: "แจ้งรถแล้ว",
  noContainerPicture: "ยังไม่มีรูปตู้",
  hasContainerPicture: "มีรูปตู้แล้ว",
  noContainerNumber: "ยังไม่ได้เบอร์ตู้",
  notArrivedFactory: "ยังไม่ถึง รง.",
  shippingStatus: "สถานะ Shipping",
  workNotFinished: "งานยังไม่จบ",
  appointmentDate: "วันที่นัดเข้า รง.",

  // Additional shipping terms
  truckHead: "หัวลาก",
  containerCount: "จำนวนตู้",
  truckNotification: "แจ้งรถ",
  print: "Print",
  notifyCustomer: "แจ้งลูกค้า",
  gotContainerNumber: "ได้เบอร์ตู้",
  arrivedFactory: "ถึง รง.",
  workCompleted: "งานจบ",
  containerPictures: "รูปตู้",
  sequenceNumber: "ลำดับ",
  files: "Files",
  documentsComplete: "Doc ครบ",
  No: "ลำดับ",
  RecvDocDte: "เวลารับงาน",
  IsOwnTuk: "ใช้ DOC CTT",
  notIsOwnTuk: "ไม่ใช้ DOC CTT",
}